import React from 'react';

const VARIANT_CLASSES = {
  danger: 'text-danger bg-danger/10',
  warning: 'text-warning bg-warning/10',
  // Map info to success styling so positive signals render green consistently.
  info: 'text-success bg-success/10',
  neutral: 'text-text-muted bg-background-tertiary',
  warm: 'text-accent-warm-base bg-accent-warm-base/10',
};

const SignalPill = ({ label, variant = 'neutral', className = '', title }) => {
  const variantClass = VARIANT_CLASSES[variant] || VARIANT_CLASSES.neutral;
  return (
    <span
      className={`px-2 py-0.5 rounded-full text-[11px] font-medium border border-border-strong truncate ${variantClass} ${className}`.trim()}
      title={title}
    >
      {label}
    </span>
  );
};

export default SignalPill;
